<template>
  <layout-vertical>
    <router-view />

    <template #navbar="{ toggleVerticalMenuActive }">
      <navbar :toggle-vertical-menu-active="toggleVerticalMenuActive" />

      <help-desks-issue-floating />
    </template>

    <app-customizer
      v-if="showCustomizer"
      slot="customizer"
    />
  </layout-vertical>
</template>

<script>
import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
import { $themeConfig } from '@themeConfig'

import HelpDesksIssueFloating from '@/components/HelpDesksIssueFloating.vue'

import Navbar from '../components/Navbar.vue'

import { trackingMixin } from '../../trackingMixins'


export default {
  components: {
    AppCustomizer,
    LayoutVertical,
    Navbar,
    HelpDesksIssueFloating,
  },
  mixins: [trackingMixin],
  data() {
    return {
      showCustomizer: $themeConfig.layout.customizer,
    }
  },
}
</script>
